import { put, call, take } from 'redux-saga/effects';

import { OCR_CONTEXT } from '../../../constants';
import { INSURANCE_ELIGIBILITY_FIELDS_TYPES } from '../../../constants/formFields';

import {
  actions as checkUploadedInsuranceCardOcrActions,
  consts as checkUploadedInsuranceCardOcrConsts,
} from '../requests/check-uploaded-insurance-card-ocr';

const {
  MEMBER_ID,
  GROUP_NUMBER,
  HEALTH_PLAN,
} = INSURANCE_ELIGIBILITY_FIELDS_TYPES;

const mapCheckOcrResultToFormValues = result => {
  const data = {};

  if (!result) return data;

  const { fields } = result;

  const { payer, memberId, groupNumber } = {
    ...fields,
  };

  const { id, name } = { ...payer };

  if (memberId) {
    data[MEMBER_ID] = memberId;
  }

  if (groupNumber) {
    data[GROUP_NUMBER] = groupNumber;
  }

  if (id && name) {
    data[HEALTH_PLAN] = {
      id,
      value: name,
      label: name,
    };
  } else {
    data[HEALTH_PLAN] = null;
  }

  return data;
};

export function* checkInsuranceCardOcr(payload) {
  const {
    userId,
    handleFormChange,
    recordType,
    recordId,
    additionalDataToUpdate = {},
  } = payload;

  yield put(
    checkUploadedInsuranceCardOcrActions.send({
      record_type: recordType,
      record_id: recordId,
      ocr_context: OCR_CONTEXT.INSURANCE_CARD,
      userId,
    }),
  );

  const checkOcrResult = yield take(
    checkUploadedInsuranceCardOcrConsts.SUCCEED,
  );

  const { payload: checkOcrPayload } = checkOcrResult;

  const formValues = yield call(mapCheckOcrResultToFormValues, checkOcrPayload);

  handleFormChange({ ...formValues, ...additionalDataToUpdate });
}



// WEBPACK FOOTER //
// ./src/redux/manage-insurances/sagas/check-insurance-card-ocr.js